import React from 'react';
import styles from './HowItWorks.module.scss';
import iconAvailability from '../../../images/business-solutions-icon-availability.png';
import iconPlan from '../../../images/business-solutions-icon-plan.png';
import iconAgreement from '../../../images/business-solutions-icon-agreement.png';
import iconConstruction from '../../../images/business-solutions-icon-construction.png';
import iconGoLive from '../../../images/business-solutions-icon-golive.png';

const steps = [
  {
    icon: iconAvailability,
    title: 'Check Availability',
    description: 'We confirm service availability at your address and learn more about your business needs.',
  },
  {
    icon: iconPlan,
    title: 'Plan our Connection',
    description: 'We review the property, equipment location, and the best installation path.',
  },
  {
    icon: iconAgreement,
    title: 'Agreement',
    description: 'Choose your service package, confirm the details, and sign your agreement.',
  },
  {
    icon: iconConstruction,
    title: 'Construction',
    description: 'We coordinate buildout, complete the fiber path, and install the necessary equipment.',
  },
  {
    icon: iconGoLive,
    title: 'Go Live',
    description: 'We test and activate your service so your business is ready to go.',
  },
];

export const HowItWorks = (): React.JSX.Element => {
  return (
    <section id="how-it-works" className={styles.howItWorks}>
      <div className="grid-12">
        <div className={styles.container}>
          <p className={styles.eyebrow}>How it Works</p>
          <h2 className={`${styles.headline} color--marina-blue`}>
            A straightforward process.
          </h2>
          <p className={styles.subtext}>
            A clear path to getting your business connected with fast, reliable fiber-optic
            internet.
          </p>

          <div className={styles.steps}>
            {steps.map((step) => (
              <div key={step.title} className={styles.step}>
                <div className={styles.iconWrap}>
                  <img src={step.icon} alt="" width="55" height="50" loading="lazy" />
                </div>
                <p className={styles.stepTitle}>{step.title}</p>
                <p className={styles.stepDescription}>{step.description}</p>
              </div>
            ))}
          </div>

          <p className={styles.disclaimer}>
            Installation timelines vary based on permitting, construction requirements, and
            property access. Your Cityside Fiber representative will keep you updated throughout
            the process.
          </p>
        </div>
      </div>
    </section>
  );
};
